import {
    AnimationProperty,
    FullScreenContainer,
    ScreenParameters
} from '@gongxigames/framework/core';
import {PopupFaderSpineConfig, PopupFaderConfig} from '@gongxigames/framework/slot/types';
import {Fader, CallBack} from '@gongxigames/framework/slot/modules/genericPopup/fader/Fader';

export class FaderSpine extends Fader {
    static testSettingsType(config: PopupFaderConfig): boolean {
        return !!(config as PopupFaderSpineConfig).spine;
    }

    private fullscreenContainer?: FullScreenContainer;

    public show(cb: CallBack): void {
        const {container, displayObjectUtils} = this;
        const {height, width} = this.getConfig();

        this.fullscreenContainer = displayObjectUtils.createFullScreenContainer({
            contentHeight: height,
            contentWidth: width
        });

        container.addChild(this.fullscreenContainer);

        this.setupAnimations();
        this.setFadeAnimation(cb);

        this.container.visible = true;
    }

    public resize(screenParams: ScreenParameters): void {
        this.fullscreenContainer?.resize(screenParams);
    }

    private setFadeAnimation(cb: CallBack): void {
        const {updater} = this;
        const duration = this.getFadeDuration();

        this.fullscreenContainer!.alpha = 0;

        updater.addTween(this.fullscreenContainer)
            .to({alpha: 1}, duration)
            .start()
            .onComplete(cb);
    }

    private setupAnimations(): void {
        const {spine: spineConfig} = this.getConfig();
        const {spineUtils, updater} = this;
        const spine = this.objectBuilder.buildSpineWithConfig(spineConfig);
        const animations = this.getAnimations();

        spineUtils.applyMasks(spine);
        updater.add(spine);
        spine.start();
        this.fullscreenContainer?.addChild(spine);

        const playAnimation = () => {
            const animation = animations.shift();

            if (!animation) {
                return;
            }

            spine.setAnimation({
                ...animation,
                listeners: { complete: () => {
                    spine.clearAllAnimationEvents();
                    spine.state.clearListeners();

                    playAnimation();
                } }
            });
        };

        playAnimation();
    }

    protected getFadeDuration(): number {
        const {start} = this.getConfig();
        const {fadeDuration} = this.config;

        if (fadeDuration !== undefined) {
            return fadeDuration;
        }

        if (!start) {
            super.getFadeDuration();
        }

        return 0;
    }

    private getConfig() {
        return this.config as PopupFaderSpineConfig;
    }

    private getAnimations(): AnimationProperty[] {
        const {start, idle} = this.getConfig();
        const animations = [];

        if (start) {
            animations.push({
                animationName: start.name,
                skinName: start.skin,
                loop: false
            });
        }

        animations.push({
            animationName: idle.name,
            skinName: idle.skin,
            loop: true
        });

        return animations;
    }
};